// eslint-disable-next-line import/no-extraneous-dependencies
import React, { useState, useEffect } from 'react'
import { StatGroup, SectionHeaderProps } from './utils/types.ts'
import { SIDE_BUFFER, LEFT_SIDE_BUFFER } from './utils/constants.ts'
import { useDimensions } from './utils/responsive-dimensions.tsx'

const VALUE_IMAGE_PATH =
    '/sections/player-update/images/sliders/slider-trophy.png'
const BATTING_IMAGE_PATH =
    '/sections/player-update/images/sliders/slider-batter.png'
const CATCHING_IMAGE_PATH =
    '/sections/player-update/images/sliders/slider-catcher.png'
const RUNNING_IMAGE_PATH =
    '/sections/player-update/images/sliders/slider-runner.png'
const FIELDING_IMAGE_PATH =
    '/sections/player-update/images/sliders/slider-fielder.png'
const PITCHING_IMAGE_PATH =
    '/sections/player-update/images/sliders/slider-pitcher.png'

const pathVarMap: Record<StatGroup, string> = {
    value: VALUE_IMAGE_PATH,
    batting: BATTING_IMAGE_PATH,
    catching: CATCHING_IMAGE_PATH,
    running: RUNNING_IMAGE_PATH,
    fielding: FIELDING_IMAGE_PATH,
    pitching: PITCHING_IMAGE_PATH,
}

function getSectionName(type: StatGroup) {
    if (type === 'value') {
        return 'Run Value'
    }

    return `${type.charAt(0).toUpperCase() + type.slice(1)}`
}

function SectionHeader(props: SectionHeaderProps) {
    const { type, numPlayers, maxSliderWidth } = props
    const { SLIDER_OFFSET_FROM_TEXT, BETWEEN_PLAYERS_BUFFER } = useDimensions()

    const pathVar = pathVarMap[type]
    const [imageBase64, setImageBase64] = useState<string | null>(null)

    useEffect(() => {
        fetch(pathVar)
            .then((response) => {
                if (!response.ok) throw new Error('Failed to fetch local image')
                return response.blob()
            })
            .then((blob) => {
                const reader = new FileReader()
                reader.onloadend = () => {
                    setImageBase64(reader.result as string)
                }
                reader.readAsDataURL(blob)
            })
            .catch((err) => console.error('Failed to load section image', err))
    }, [pathVar])

    const rightSideX =
        LEFT_SIDE_BUFFER +
        SLIDER_OFFSET_FROM_TEXT +
        numPlayers * (BETWEEN_PLAYERS_BUFFER + maxSliderWidth) -
        BETWEEN_PLAYERS_BUFFER

    return (
        <g>
            {imageBase64 && (
                <image
                    href={imageBase64}
                    aria-label={`${type} logo`}
                    x="7"
                    y="0"
                    width="45"
                    height="45"
                    crossOrigin="anonymous"
                />
            )}
            <text
                x="50"
                y="35"
                className="section-header-text-label"
                style={{ fontFamily: 'Roboto Condensed' }}
            >
                {getSectionName(type)}
            </text>
            <line
                x1={SIDE_BUFFER}
                x2={rightSideX}
                y1="42"
                y2="42"
                className="section-header-line"
            />
        </g>
    )
}

export default SectionHeader
